import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';

/**
 * Feed activo del grupo. Producto según el contexto:
 * - group_web: feed del grupo administrado (UX histórica).
 * - dealership_web: feed del grupo de la concesionaria (DOM-AUC-005); la
 *   gestión de cada subasta sigue exigiendo la membership de su unidad.
 *
 * Un fallo del feed (p.ej. backend aún sin desplegar el permiso nuevo) NO
 * invalida la sesión: el consumidor hace fallback al listado de la unidad.
 */
export const getGroupActiveAuctions = async (currentUser, startDate = null, endDate = null) => {
  const isDealership = currentUser?.activeApp === 'dealership_web';
  if (
    isDealership &&
    !currentUser?.permissions?.includes('auctions.view_group_feed')
  ) {
    return { success: 'no', message: 'Feed del grupo no habilitado' };
  }
  try {
    const getActiveAuctionsFn = httpsCallable(functions, 'getActiveAuctionsByGroupV2');
    const result = await getActiveAuctionsFn({
      groupId: currentUser.groupId || currentUser.activeGroupId,
      requestedApp: isDealership ? 'dealership_web' : 'group_web',
      operatingUnitId: isDealership ? currentUser.activeUnitId || undefined : undefined,
      dealershipId: isDealership ? currentUser.dealershipId || undefined : undefined,
      startDate: startDate instanceof Date ? startDate.getTime() : null,
      endDate: endDate instanceof Date ? endDate.getTime() : null,
    });

    if (result.data.success === 'yes') {
      return {
        docs: result.data.data.map((auction) => ({
          id: auction.id,
          data: () => auction,
        })),
      };
    } else {
      return { success: 'no', message: result.data.message };
    }
  } catch (error) {
    console.error('Error getting group active auctions:', error);
    return { success: 'no', message: error.message };
  }
};
